import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnInit,
  Renderer2,
} from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { ApiService } from "src/app/services/api/api.service";
import { PopupService } from "src/app/services/shared/popup.service";
import { StateService } from "src/app/services/shared/state.service";
import { CheckIfUserUsingBlocker } from "src/app/utils/checkForAdBlocker";
import { slideInAnimation } from "src/app/utils/entry-animation";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  animations: [slideInAnimation],
})
export class DashboardComponent implements OnInit {
  constructor(
    public renderer: Renderer2,
    public popupService: PopupService,
    public apiService: ApiService,
    public stateService: StateService
  ) {}

  ngOnInit(): void {
    this.CheckAdBlocker();
    this.HideMainScroll();
    this.Test();
  }

  public async Test() {
    const result = await this.apiService.GetKey({
      companyId: 125,
      isSharingMode: true,
    });
    console.log("data:" + result?.data);
    let original;
    if (result?.data)
      original = await this.apiService.ResolveKey(
        "VTJGc2RHVmtYMTlUVjRwUGVQTzNQVEQ1SW12T01DMjJES3BZVTNWR1dPb0x0SFk2d1lCczdjSkt1V0NYRFpGbQ"
      );
    console.log(original?.data);
  }
  public HideMainScroll() {
    this.renderer.addClass(document.body, "no-scroll");
  }

  public PrepareRoute(outlet: RouterOutlet) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData["animation"]
    );
  }

  public CheckAdBlocker() {
    if (CheckIfUserUsingBlocker())
      this.popupService.Notify(
        "For a seamless browsing experience, please deactivate your ad blockers."
      );
  }
}
